import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpCustomerService } from '../../../service/httpcustomer.service';
import { WebParameterContext, viewData } from '../../../model/common';
import { CommonService } from '../../../service/common.service';
import { BaseCase } from '../../../app/basecase';
import { GridBaseCase } from '../grid/grid.base.case';

declare var app;

@Component({
  selector: 'app-notice-detail',
  templateUrl: './notice-detail.component.html',
  styleUrls: ['./notice-detail.component.scss']
})
export class NoticeDetailComponent extends GridBaseCase implements OnInit {

  title: string;
  data: any = { head: "",name: "", title: "", date: "", content: "" };
  constructor(
    private router: ActivatedRoute,
    private http: HttpCustomerService,
    private com: CommonService,
    private baseService: BaseCase
  ) {
    super();
  }
  ngOnInit() {
    const that = this;
    const ConfigName = this.router.snapshot.paramMap.get("type");
    const element = that.com.GetStorageKey('element');
    const id = this.router.snapshot.paramMap.get("id");

    if (ConfigName && id && element) {
      const body = new WebParameterContext();
      body.ConfigName = ConfigName;
      body.OpType = "GET";
      body.ConfigType = "form";
      body.Client.PageName = ConfigName;
      body.Client.Name = ConfigName;
      body.RequestBody = JSON.stringify({ 'a_ID': id });
      this.http.post(app.DEFAULTURL, body).then(data => {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
        if (data.ResponseMessage.Success) {
          element.selectItemList.selectItem.forEach(item => {
            if (item.bindingField == 'title') {
              // that.baseService.pageTitle = data.Status[item.field];
              that.data.title = data.Status[item.field];
            } else if (item.bindingField == 'date') {
              that.data.date = data.Status[item.field];
            } else if (item.bindingField == 'content') {
              that.data.content = decodeURI(data.Status[item.field]);
            } else if (item.bindingField == 'name') {
              that.data.name = data.Status[item.field];
            }
          });
          //console.log(that.data,'that.data');
        } else {
          console.log(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
        that.loading = true;
      })
    }

  }

}
